import React, { useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Column, LocaleContext, Row, UploadField } from 'shared';

import { LogoLabel } from './AddTppLogo.styles';

const allowedExtensions = ['.png'];

const formatFile = (value?: any) => {
  try {
    return value ? [btoa(value)] : [];
  } catch (error) {
    return [];
  }
};

const parseFile = (value?: any) => {
  try {
    return value && value[0] ? value[0].split(',')[1] : '';
  } catch (error) {
    return '';
  }
};

export const AddTppLogo = (properties?: any) => {
  const localeContext = useContext(LocaleContext);
  const labelValue = properties && properties.labelValue ? properties.labelValue : 'FORM.TPP-LOGO-UPLOAD';

  return (
    <Row flexDirection={['column', 'row']} alignItems={['flex-start']} mt="2rem">
      <Column size={[12, 4]}>
        <LogoLabel style={{ lineHeight: '2rem' }}>{localeContext.formatMessage({ id: 'FORM.TPP-LOGO' })}</LogoLabel>
      </Column>
      <Column size={[12, 8]}>
        <Field name="logoEncoded" format={formatFile} parse={parseFile}>
          {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
            <UploadField
              label={localeContext.formatMessage({ id: labelValue })}
              input={input}
              meta={meta}
              className={'tpp-logo'}
              multiple={false}
              maxFilesize={10 ** 6}
              maxCount={1}
              allowedExtensions={allowedExtensions}
            />
          )}
        </Field>
      </Column>
    </Row>
  );
};
